module.exports = "/images/model_41a2d5.png";